import React from 'react'
import { useRouteError } from 'react-router-dom'

export default function RoutingErrorPage() {
    const error = useRouteError()
    console.log(error)

    return (
        <div>
            <h2>Oops</h2>
            <div>{error.statusText}</div>
        </div>
    )
}
